/**
 * R66 协议路由与版本判定（URL apilevel ≥ 40660 或 getAppInfo.app_version ≥ 4.66.00）
 * 依赖：App-JSBridge.js（Legacy）、App-WebContainer-Bridge-R66.js
 */
(function (global) {
  'use strict';

  var PROTOCOL_APILEVEL = 40660;
  var PROTOCOL_MIN_APP_VERSION = '4.66.00';
  var FEATURE_COMPACT_NAV_MIN_VERSION = '4.66.00';
  /** APP 版本不会变；卸装清 WebView 存储。只持久化确认过的 r66，不存 timeout 误判的 legacy。 */
  var TIER_STORAGE_KEY = '__rr_protocol_tier__';
  var TIER_REASON_KEY = '__rr_protocol_tier_reason__';
  var TIER_APILEVEL_KEY = '__rr_mall_apilevel__';
  var TIER_UPDATED_AT_KEY = '__rr_protocol_tier_updated_at__';
  var MALL_ID_LOCAL_KEY = '__rr_mall_token_id__';

  var _tierCache = null;
  var _tierReasonCache = null;
  var _tierPromise = null;
  var _loggedHydrate = false;

  function isAppWebView() {
    try {
      if (typeof global.__rrMallIsAppWebView__ === 'function') {
        return !!global.__rrMallIsAppWebView__();
      }
    } catch (e) {}
    return /RR_MALL_(Android|IOS|Harmony)/i.test(
      (global.navigator && global.navigator.userAgent) || ''
    );
  }

  function parseApiLevel(raw) {
    if (raw == null || raw === '') return NaN;
    var n = parseInt(String(raw).replace(/^\s+|\s+$/g, ''), 10);
    return n;
  }

  /** apilevel 门槛：≥ 40660 即为 R66，不是只等于 40660 */
  function isR66ApiLevel(raw) {
    var n = parseApiLevel(raw);
    return !isNaN(n) && n >= PROTOCOL_APILEVEL;
  }

  function getUrlApiLevel() {
    try {
      return new URLSearchParams(global.location.search).get('apilevel');
    } catch (e) {
      return null;
    }
  }

  function persistConfirmedR66(reason, apiLevel) {
    if (!isAppWebView()) return;
    _tierCache = 'r66';
    _tierReasonCache = reason || 'r66';
    var nextLevel = isR66ApiLevel(apiLevel) ? String(parseApiLevel(apiLevel)) : null;
    try {
      var prevTier = global.localStorage.getItem(TIER_STORAGE_KEY);
      var prevLevel = global.localStorage.getItem(TIER_APILEVEL_KEY);
      if (prevTier === 'r66' && (!nextLevel || prevLevel === nextLevel)) {
        return;
      }
      global.localStorage.setItem(TIER_STORAGE_KEY, 'r66');
      global.localStorage.setItem(TIER_REASON_KEY, _tierReasonCache);
      global.localStorage.setItem(TIER_UPDATED_AT_KEY, String(Date.now()));
      if (nextLevel) {
        global.localStorage.setItem(TIER_APILEVEL_KEY, nextLevel);
      }
    } catch (e) {}
  }

  function hydratePersistedR66() {
    if (!isAppWebView()) return false;
    if (_tierCache === 'r66') return true;
    try {
      var storedTier = global.localStorage.getItem(TIER_STORAGE_KEY);
      var storedLevel = global.localStorage.getItem(TIER_APILEVEL_KEY);
      if (storedTier === 'r66' || isR66ApiLevel(storedLevel)) {
        _tierCache = 'r66';
        _tierReasonCache = global.localStorage.getItem(TIER_REASON_KEY) || 'localStorage';
        if (!_loggedHydrate) {
          _loggedHydrate = true;
          console.log('[ProtocolTier] hydrate localStorage', {
            tier: 'r66',
            reason: _tierReasonCache,
            apilevel: storedLevel
          });
        }
        return true;
      }
    } catch (e) {}
    return false;
  }

  function persistR66FromUrlIfPresent() {
    if (!isAppWebView()) return false;
    var level = getUrlApiLevel();
    if (!isR66ApiLevel(level)) return false;
    persistConfirmedR66('url_apilevel', level);
    return true;
  }

  /** URL 上 apilevel ≥ 40660。APP 内顺带刷新 localStorage。 */
  function hasUrlApiLevel40660() {
    persistR66FromUrlIfPresent();
    return isR66ApiLevel(getUrlApiLevel());
  }

  function compareVersion(current, minVersion) {
    if (typeof global.compareAppVersion === 'function') {
      return global.compareAppVersion(current, minVersion) >= 0;
    }
    if (typeof global.isAppVersionAtLeast === 'function') {
      return global.isAppVersionAtLeast(current, minVersion);
    }
    return false;
  }

  function isR66BridgeReady() {
    return !!(
      global.AppWebBridge &&
      typeof global.AppWebBridge.isBridgeReady === 'function' &&
      global.AppWebBridge.isBridgeReady()
    );
  }

  function fetchAppInfoPath() {
    if (global.AppWebBridge && typeof global.AppWebBridge.getAppInfo === 'function') {
      return isR66BridgeReady() ? 'AppWebBridge.getAppInfo' : 'AppWebBridge.getAppInfo(not-ready)';
    }
    if (typeof global.getAppInfo === 'function') return 'legacy.getAppInfo';
    return 'none';
  }

  /**
   * 档位探测优先走 R66 getAppInfo。
   * 有 AppWebBridge 时不要回落 Legacy getAppInfo：iOS WVJB 可能永不回调，看起来像 APP 慢。
   */
  function fetchAppInfo() {
    if (global.AppWebBridge && typeof global.AppWebBridge.getAppInfo === 'function') {
      return global.AppWebBridge.getAppInfo();
    }
    if (typeof global.getAppInfo === 'function') {
      return global.getAppInfo();
    }
    return Promise.reject(new Error('NO_GET_APP_INFO'));
  }

  function withAppInfoTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error('GET_APP_INFO_TIMEOUT'));
      }, ms);
      Promise.resolve(promise).then(
        function (value) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(value);
        },
        function (err) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          reject(err);
        }
      );
    });
  }

  function tierLog() {
    var args = ['[ProtocolTier]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function resolveProtocolTier() {
    if (!isAppWebView()) return Promise.resolve('legacy');
    var t0 = Date.now();
    persistR66FromUrlIfPresent();
    if (hydratePersistedR66() || _tierCache) {
      return Promise.resolve(_tierCache);
    }
    if (_tierPromise) {
      return _tierPromise;
    }

    var urlLevel = getUrlApiLevel();
    var urlHit = isR66ApiLevel(urlLevel);
    var viaAppInfo = fetchAppInfoPath();
    tierLog('start', {
      urlApilevel: urlLevel,
      urlR66: urlHit,
      isBridgeReady: isR66BridgeReady(),
      hasAppWebBridge: !!global.AppWebBridge,
      appInfoPath: viaAppInfo
    });

    _tierPromise = new Promise(function (resolve) {
      if (persistR66FromUrlIfPresent()) {
        tierLog('done', {
          via: 'url_apilevel',
          tier: 'r66',
          apilevel: String(parseApiLevel(urlLevel)),
          persisted: true,
          elapsedMs: Date.now() - t0
        });
        resolve('r66');
        return;
      }

      if (!global.AppWebBridge && typeof global.getAppInfo !== 'function') {
        _tierCache = 'legacy';
        _tierReasonCache = 'fallback_legacy';
        tierLog('done', {
          via: 'no-getAppInfo',
          tier: 'legacy',
          elapsedMs: Date.now() - t0
        });
        resolve('legacy');
        return;
      }

      var infoStarted = Date.now();
      withAppInfoTimeout(fetchAppInfo(), 1500)
        .then(function (info) {
          var v = info && info.app_version;
          var infoMs = Date.now() - infoStarted;
          var ok = v != null && compareVersion(v, PROTOCOL_MIN_APP_VERSION);
          if (ok) {
            persistConfirmedR66('app_version');
          } else {
            _tierCache = 'legacy';
            _tierReasonCache = 'fallback_legacy';
          }
          tierLog('getAppInfo returned', {
            path: viaAppInfo,
            elapsedMs: infoMs,
            app_version: v,
            isBridgeReady: isR66BridgeReady()
          });
          tierLog('done', {
            via: _tierReasonCache,
            tier: _tierCache,
            persisted: ok,
            elapsedMs: Date.now() - t0
          });
          resolve(_tierCache);
        })
        .catch(function (err) {
          var infoMs = Date.now() - infoStarted;
          _tierPromise = null;
          _tierReasonCache = 'getAppInfo_error';
          tierLog('getAppInfo error', {
            path: viaAppInfo,
            elapsedMs: infoMs,
            isBridgeReady: isR66BridgeReady(),
            err: String(err && err.message ? err.message : err)
          });
          tierLog('done', {
            via: 'getAppInfo_error',
            tier: 'legacy',
            elapsedMs: Date.now() - t0,
            cached: false
          });
          resolve('legacy');
        });
    });

    return _tierPromise;
  }

  function getProtocolTierSync() {
    hydratePersistedR66();
    return _tierCache;
  }

  function getProtocolTierReason() {
    return _tierReasonCache;
  }

  function getAppVersion() {
    if (global.AppWebBridge && typeof global.AppWebBridge.getAppVersion === 'function') {
      return global.AppWebBridge.getAppVersion();
    }
    if (typeof global.getAppVersion === 'function') {
      return global.getAppVersion();
    }
    return fetchAppInfo().then(function (info) {
      return info && info.app_version != null ? info.app_version : null;
    });
  }

  function getAppInfoUnified() {
    return resolveProtocolTier().then(function (tier) {
      if (tier === 'r66' && global.AppWebBridge && typeof global.AppWebBridge.getAppInfo === 'function') {
        return global.AppWebBridge.getAppInfo();
      }
      if (typeof global.getAppInfo === 'function') {
        return global.getAppInfo();
      }
      return Promise.reject(new Error('NO_GET_APP_INFO'));
    });
  }

  function isAppVersionAtLeastAsync(minVersion) {
    return getAppVersion().then(function (v) {
      if (v == null) return false;
      return compareVersion(v, minVersion);
    });
  }

  /** getMallTokenV2：当前 URL 有 id 则写入 localStorage（值变了才更新）；否则读 localStorage */
  function getMallTokenV2IdFromUrl() {
    try {
      var raw = new URLSearchParams(global.location.search).get('id');
      if (raw != null && raw !== '') {
        var n = parseInt(raw, 10);
        if (!isNaN(n)) {
          if (
            global.rrMallContainerQuery &&
            typeof global.rrMallContainerQuery.persistMallIdIfChanged === 'function'
          ) {
            global.rrMallContainerQuery.persistMallIdIfChanged(n);
          } else {
            try {
              var prev = global.localStorage.getItem(MALL_ID_LOCAL_KEY);
              if (String(prev) !== String(n)) {
                global.localStorage.setItem(MALL_ID_LOCAL_KEY, String(n));
              }
            } catch (e) {}
          }
          return n;
        }
      }
    } catch (e) {}
    try {
      if (
        global.rrMallContainerQuery &&
        typeof global.rrMallContainerQuery.getPersistedMallId === 'function'
      ) {
        var localId = global.rrMallContainerQuery.getPersistedMallId();
        if (localId != null) return localId;
      }
    } catch (e2) {}
    try {
      var stored = global.localStorage.getItem(MALL_ID_LOCAL_KEY);
      if (stored != null && stored !== '') {
        var sid = parseInt(stored, 10);
        if (!isNaN(sid)) return sid;
      }
    } catch (e3) {}
    return null;
  }

  function buildMallTokenV2InvokeParams(opts) {
    var p =
      opts && opts.params != null && typeof opts.params === 'object'
        ? Object.assign({}, opts.params)
        : {};
    var urlId = getMallTokenV2IdFromUrl();
    if (urlId != null) {
      p.id = urlId;
    } else {
      delete p.id;
    }
    return p;
  }

  var invokeHandlers = {
    getUserInfo: {
      legacy: function () {
        return global.getUserInfo();
      },
      r66: function () {
        return global.AppWebBridge.getUserInfo();
      },
    },
    getAppInfo: {
      legacy: function () {
        return global.getAppInfo();
      },
      r66: function () {
        return global.AppWebBridge.getAppInfo();
      },
    },
    getAppMallToken: {
      legacy: function () {
        return global.getAppMallToken();
      },
      r66: function (opts) {
        if (opts && opts.useV2) {
          return global.AppWebBridge.getMallTokenV2(buildMallTokenV2InvokeParams(opts));
        }
        if (opts && opts.params != null) {
          return global.AppWebBridge.getMallToken(opts.params);
        }
        return global.AppWebBridge.getAppMallToken();
      },
    },
    hideAppTabBar: {
      legacy: function (hide) {
        global.hideAppTabBar(hide !== false);
        return Promise.resolve({ hidden: hide !== false });
      },
      r66: function (hide) {
        return global.AppWebBridge.toggleTabBarVisible(hide === false);
      },
    },
    showAppTabBar: {
      legacy: function () {
        if (typeof global.showAppTabBar === 'function') {
          global.showAppTabBar();
        } else {
          global.hideAppTabBar(false);
        }
        return Promise.resolve({ visible: true });
      },
      r66: function () {
        return global.AppWebBridge.toggleTabBarVisible(true);
      },
    },
    closeCurrentPage: {
      legacy: function () {
        global.closeCurrentPage();
        return Promise.resolve({ called: true });
      },
      r66: function () {
        global.AppWebBridge.goBack();
        return Promise.resolve({ called: true });
      },
    },
    getStatusBarHeight: {
      legacy: function () {
        return global.getStatusBarHeight();
      },
      r66: function () {
        return global.AppWebBridge.getStatusBarHeight();
      },
    },
  };

  function dispatchInvoke(tier, method, args) {
    var handler = invokeHandlers[method];
    if (!handler) {
      if (tier === 'r66' && global.AppWebBridge && typeof global.AppWebBridge[method] === 'function') {
        return global.AppWebBridge[method].apply(global.AppWebBridge, args);
      }
      if (typeof global[method] === 'function') {
        return Promise.resolve(global[method].apply(global, args));
      }
      return Promise.reject(new Error('UNKNOWN_METHOD: ' + method));
    }
    var fn = tier === 'r66' ? handler.r66 : handler.legacy;
    if (!fn) {
      return Promise.reject(new Error('NOT_IMPLEMENTED_FOR_TIER: ' + method + '/' + tier));
    }
    if (tier === 'r66' && !global.AppWebBridge) {
      return Promise.reject(new Error('R66_BRIDGE_NOT_READY'));
    }
    return Promise.resolve(fn.apply(null, args));
  }

  function invoke(method) {
    var args = Array.prototype.slice.call(arguments, 1);
    var cached = getProtocolTierSync();
    if (cached) {
      return dispatchInvoke(cached, method, args);
    }
    return resolveProtocolTier().then(function (tier) {
      return dispatchInvoke(tier, method, args);
    });
  }

  function resetProtocolTierCache(clearPersist) {
    _tierCache = null;
    _tierReasonCache = null;
    _tierPromise = null;
    _loggedHydrate = false;
    if (clearPersist) {
      try {
        global.localStorage.removeItem(TIER_STORAGE_KEY);
        global.localStorage.removeItem(TIER_REASON_KEY);
        global.localStorage.removeItem(TIER_APILEVEL_KEY);
        global.localStorage.removeItem(TIER_UPDATED_AT_KEY);
      } catch (e) {}
    }
  }

  var AppBridge = {
    PROTOCOL_APILEVEL: PROTOCOL_APILEVEL,
    PROTOCOL_MIN_APP_VERSION: PROTOCOL_MIN_APP_VERSION,
    FEATURE_COMPACT_NAV_MIN_VERSION: FEATURE_COMPACT_NAV_MIN_VERSION,
    hasUrlApiLevel40660: hasUrlApiLevel40660,
    resetProtocolTierCache: resetProtocolTierCache,
    getProtocolTier: resolveProtocolTier,
    getProtocolTierSync: getProtocolTierSync,
    getProtocolTierReason: getProtocolTierReason,
    getAppVersion: getAppVersion,
    getAppInfo: getAppInfoUnified,
    isAppVersionAtLeastAsync: isAppVersionAtLeastAsync,
    invoke: invoke,
    features: {
      compactNavEnabled: function () {
        if (hydratePersistedR66()) return Promise.resolve(true);
        if (global.AppWebBridge && typeof global.AppWebBridge.isAppVersionAtLeast === 'function') {
          return global.AppWebBridge.isAppVersionAtLeast(FEATURE_COMPACT_NAV_MIN_VERSION);
        }
        return isAppVersionAtLeastAsync(FEATURE_COMPACT_NAV_MIN_VERSION);
      },
    },
  };

  global.AppBridge = AppBridge;

  hydratePersistedR66();
  persistR66FromUrlIfPresent();
})(typeof window !== 'undefined' ? window : this);
